
import React from 'react';
import { AlertCircle } from 'lucide-react';

export const AccessDenied: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh]">
      <AlertCircle className="h-16 w-16 text-destructive mb-4" />
      <h1 className="text-2xl font-bold mb-2">Access Denied</h1>
      <p className="text-muted-foreground">You don't have permission to view this page.</p>
      <p className="text-muted-foreground">This area is restricted to administrators only.</p>
    </div>
  );
};
